// src/redux/slices/invoiceDrawerSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IInvoiceDrawerState {
    show: boolean;
    appointmentId?: number;
    invoiceId?: number;
    onSaveDraft?: () => void;
    onCheckout?: () => void;
}

export const initialStateInvoiceDrawer: IInvoiceDrawerState = {
    show: false,
    invoiceId: undefined,
    appointmentId: undefined,
    onCheckout: undefined,
    onSaveDraft: undefined,
};

const invoiceDrawerSlice = createSlice({
    name: "invoiceDrawer",
    initialState: initialStateInvoiceDrawer,
    reducers: {
        createNewInvoice: () => {
            return {
                show: true,
                appointmentId: undefined,
                invoiceId: undefined,
                onSaveDraft: undefined,
                onCheckout: undefined,
            };
        },
        showInvoiceDrawer: (state, action: PayloadAction<Omit<IInvoiceDrawerState, "show">>) => {
            return {
                invoiceId: undefined,
                appointmentId: undefined,
                onSaveDraft: undefined,
                onCheckout: undefined,
                // want to clear out the previous state
                ...action.payload,
                show: true,
            };
        },
        hideInvoiceDrawer: () => initialStateInvoiceDrawer,
    },
});

export const { showInvoiceDrawer, hideInvoiceDrawer } = invoiceDrawerSlice.actions;
export default invoiceDrawerSlice.reducer;
